export default {
	/**
	 * Resolves an array of monitor action group template objects from the API.
	 *
	 * @returns {Promise<array>}
	 */
	async allActionGroupTemplates () {},

	/**
	 * Stores a new monitor action group template.
	 *
	 * @param {string} name The name of the new template
	 * @returns {Promise<object>}
	 */
	async storeActionGroupTemplate (name) {},

	/**
	 * Updates the monitor action group template at the given ID.
	 *
	 * @param {int} id The ID of the monitor action group template to update
	 * @param {string} name The new name of the template
	 * @returns {Promise<object>}
	 */
	async updateActionGroupTemplate (id, name) {},

	/**
	 * Deletes the monitor action group template at the given ID.
	 *
	 * @param {int} id The ID of the monitor action group template
	 * @returns {Promise}
	 */
	async deleteActionGroupTemplate (id) {},

	/**
	 * Stores a new action group with the given template and monitor action IDs.
	 *
	 * @param {int} templateId The ID of the related monitor action group template
	 * @param {int} successActionId The ID of the related "success" monitor action
	 * @param {int} failureActionId The ID of the related "failure" monitor action
	 * @returns {Promise<object>}
	 */
	async storeActionGroup (templateId, successActionId, failureActionId) {},

	/**
	 * Deletes the action group with the given ID and monitor action group template ID.
	 *
	 * @param {int} templateId The ID of the related monitor action group template
	 * @param {int} actionGroupId The ID of the related monitor action group
	 * @returns {Promise}
	 */
	async deleteActionGroup (templateId, actionGroupId) {},

	/**
	 * Resolves an array of action types from the API.
	 *
	 * @returns {Promise<array>}
	 */
	async actionTypes () {},

	/**
	 * Stores a new monitor action.
	 *
	 * @param {string} type The type of the action to store
	 * @param {object} settings The settings object
	 * @returns {Promise<object>}
	 */
	async storeAction (type, settings) {},

	/**
	 * Retrieves an array of monitors from the given client and group ID.
	 *
	 * @param {int} clientId The client ID to query against
	 * @param {int} groupId The group ID to query against
	 * @returns {Promise<array>}
	 */
	async getFromGroup (clientId, groupId) {},

	/**
	 * Stores a new monitor.
	 *
	 * @param {string} type The type of resource that we're storing the monitor on. Can be 'client', 'group', or 'device'.
	 * @param {int} resourceId The ID of the resource to store the monitor on
	 * @param {string} name The monitor name
	 * @param {string} monitorType The monitor type key
	 * @param {string} thresholdCondition The threshold condition
	 * @param {string} timezone The timezone of the monitor
	 * @param {int} failureNotificationThreshold The failure notification threshold
	 * @param {string} cron The cron expression
	 * @param {bool} isActive Flag for whether the monitor is active
	 * @param {int} magTemplateId The monitor action group template ID
	 * @param {object} settings An encapsulated object containing setting values.
	 * @returns {Promise<object>}
	 */
	async storeMonitor (
		type,
		resourceId,
		name,
		monitorType,
		thresholdCondition,
		timezone,
		failureNotificationThreshold,
		cron,
		isActive,
		magTemplateId,
		settings
	) {},

	/**
	 * Updates an existing monitor.
	 *
	 * @param {int} monitorId The monitor ID to update
	 * @param {string} type The type of resource that we're updating the monitor on. Can be 'client', 'group', or 'device'.
	 * @param {int} resourceId The ID of the resource the monitor is assigned to
	 * @param {string} name The monitor name
	 * @param {string} monitorType The monitor type key
	 * @param {string} thresholdCondition The threshold condition
	 * @param {string} timezone The timezone of the monitor
	 * @param {int} failureNotificationThreshold The failure notification threshold
	 * @param {string} cron The cron expression
	 * @param {bool} isActive Flag for whether the monitor is active
	 * @param {int} magTemplateId The monitor action group template ID
	 * @param {object} settings An encapsulated object containing setting values.
	 * @returns {Promise<object>}
	 */
	async updateMonitor (
		monitorId,
		type,
		resourceId,
		name,
		monitorType,
		thresholdCondition,
		timezone,
		failureNotificationThreshold,
		cron,
		isActive,
		magTemplateId,
		settings
	) {},

	/**
	 * Overrides an existing monitor.
	 *
	 * @param {int} monitorId The monitor ID to override
	 * @param {string} type The type of the resource that is overriding the monitor. Can be 'client', 'group', or 'device'.
	 * @param {int} resourceId The ID of the resouce that is overriding the monitor.
	 * @returns {Promise<object>} The new monitor created from the existing one.
	 */
	async overrideMonitor (monitorId, type, resourceId) {},

	/**
	 * Deletes the monitor with the given ID.
	 *
	 * @param {int} monitorId The monitor ID to delete
	 * @returns {Promise}
	 */
	async deleteMonitor (monitorId) {},

	/**
	 * Activates the monitor with the given ID.
	 *
	 * @param {int} monitorId The monitor ID to activate
	 * @returns {Promise<object>}
	 */
	async activateMonitor (monitorId) {},

	/**
	 * Deactivates the monitor with the given ID.
	 *
	 * @param {int} monitorId The monitor ID to deactivate
	 * @returns {Promise<object>}
	 */
	async deactivateMonitor (monitorId) {},

	/**
	 * Activates the inherited monitor with the given ID.
	 *
	 * @param {int} monitorId The inherited monitor ID to activate
	 * @param {string} monitoredType The type of resource that's inheriting the monitor. Can be 'group' or 'device'
	 * @param {int} monitoredId The ID of the resource that's inheriting the monitor.
	 * @returns {Promise<object>}
	 */
	async activateInheritedMonitor (monitorId, monitoredType, monitoredId) {},

	/**
	 * Deactivates the inherited monitor with the given ID.
	 *
	 * @param {int} monitorId The inherited monitor ID to deactivate
	 * @param {string} monitoredType The type of resource that's inheriting the monitor. Can be 'group' or 'device'
	 * @param {int} monitoredId The ID of the resource that's inheriting the monitor.
	 * @returns {Promise<object>}
	 */
	async deactivateInheritedMonitor (monitorId, monitoredType, monitoredId) {},

	/**
	 * Get additional details of a monitor scoped to the query string
	 *
	 * @param {int} id id of the monitor
	 * @param {string} queryString the level and id of the item(s) we will get details for
	 */
	getDetails (id, queryString) {},

	/**
	 * Run a monitor on command
	 *
	 * @param {int} id id of the monitor
	 */
	runMonitor (id) {}
};
